export const BLOCK_TIME_OPTIONS = [
  { value: 10, label: "10分" },
  { value: 15, label: "15分" },
  { value: 30, label: "30分" },
  { value: 60, label: "1時間" },
  { value: 120, label: "2時間" },
];

export const BOOKING_REMINDER_TIME_OPTIONS = [
  { label: "15分", value: 15 },
  { label: "30分", value: 30 },
  { label: "1時間", value: 60 },
  { label: "2時間", value: 120 },
  { label: "3時間", value: 180 },
  { label: "5時間", value: 300 },
  { label: "6時間", value: 360 },
  { label: "10時間", value: 600 },
  { label: "12時間", value: 720 },
  { label: "24時間", value: 1440 },
  { label: "2日前", value: 2880 },
  { label: "3日前", value: 4320 },
  { label: "4日前", value: 5760 },
  { label: "1週間前", value: 10080 },
  { label: "2週間前", value: 20160 },
  { label: "3週間前", value: 30240 },
];

export const MEDIA_TYPE = {
  IMAGE: "image",
  YOUTUBE: "youtube",
};

export const BOOKING_STATUS = [
  { label: "すべて", value: "" },
  {
    value: "waiting",
    label: "予約待ち",
  },
  {
    value: "approved",
    label: "予約済み",
  },
  {
    value: "processing",
    label: "進行中",
  },
  {
    value: "done",
    label: "完了",
  },
  {
    value: "cancelled",
    label: "予約キャンセル",
  },
];

// Category type constant
export const BEAUTY_RELAX = 1;
export const MEDICAL = 2;
export const GOURMET = 0;

// Table available slot constant
export const AVAILABLE_SLOT = "AVAILABLE";

// Menu type constant
export const MENU_TYPE_ALL = "All";
export const MENU_TYPE_INDIVIDUAL = "Individual";

export const CITY_BOOKING = "booking";
